export const QuotesSortOptionsType = {
  SortByLowestPrice: 0,
  SortByFastestTime: 1,
} as const;
export type QuotesSortOptionsType =
  (typeof QuotesSortOptionsType)[keyof typeof QuotesSortOptionsType];
